import '../libs/commons';
import '../css/style_aus.css';
import $ from 'jquery';
import 'jquery.cookie';
import Nuxeo from 'nuxeo/es5';

// a 2d array to save old version html
const oldVersionHTMLList = [];

const nuxeoClient = new Nuxeo({
    baseURL: '/nuxeo'
});

function fetchDocumentsAll(param) {

    param.terumo_ifu_productCategory_agg = "[\"Australia\"]";
    param.terumo_producttype_agg = "[\"leaflet\"]";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
            }
            resultPageDocumentList(data.entries);

        })
        .catch(error => {
            console.log(error);
        });
}

$(document).ready(function () {

    const current_url = document.location.toString();
    if (current_url.indexOf("/au/") >= 0) {
        $("#common-header").load("../components/header.html", function () {
            $("#logo-top a").attr("href", "../top.html");
            $("#logo-img img").attr("src", "../images/lg_terumo.gif");
            $("#logo-globe img").attr("src", "../images/ico_globe.svg");
            externelListener();
        });
        $("#common-footer").load("../components/footer.html", function () {
            $("#privacy-and-cookie-policy a").attr("href", "../privacy-and-cookie-policy.html");
            $("#terms-of-use a").attr("href", "../terms-of-use.html");

            $('#slidershow').css("visibility", "visible");
        });
    } else {
        $("#common-header").load("./components/header.html", function () {
            externelListener();
        });
        $("#common-footer").load("./components/footer.html", function () {

            $('#slidershow').css("visibility", "visible");
        });
    }


    if ($('#cookieLayer')[0]) {
        cookieLayerInit();
    } else if ($('#disclaimer')[0]) {
        disclaimerInit();
    }

    let queryParams = {};
    fetchDocumentsAll(queryParams);

});


// old version click listener 
$(document).on('click', '[data-role="oldver"]', function (e) {
    let button_id = e.currentTarget.id;
    updateOldVersionDownloadHtml(button_id);
    if ($('html').hasClass('downloadOpen')) {
        $('html').removeClass('downloadOpen');
    } else {
        $('html').addClass('downloadOpen');
    }
    return false;
});

$(document).on('click', '#download .download-main .btnClose', function () {
    if ($('html').hasClass('downloadOpen')) {
        $('html').removeClass('downloadOpen');
    } else {
        $('html').addClass('downloadOpen');
    }
    return false;
});

/*
 * update old version html data inside "download" div 
 */
function updateOldVersionDownloadHtml(button_id) {
    let index = button_id.slice(4);
    let htmlDetailList = oldVersionHTMLList[index];
    let download_element = document.getElementById("downloaddetails");
    while (download_element.hasChildNodes()) {
        download_element.removeChild(download_element.firstChild);
    }
    download_element = $("#downloaddetails");
    download_element.html(htmlDetailList);
}


/* 
 * sort Australia page doucument list 
 */
function resultPageDocumentList(documents) {
    let aus_document_element = $("#rtList");

    if (documents.length === 0) {
        aus_document_element.html("No Results");
        return;
    }

    //let document_lists = Array.from(documents);
    let document_lists = documents.slice();
    /*
     * sort by the order:
     * directory_brandname---leaflet_brandname---versionableId---versionLabel---issuedate
     * noticed here we use inverse sorting
     */
    sortByWhat(document_lists, "issuedate");
    sortByWhat(document_lists, "versionLabel");
    sortByWhat(document_lists, "versionableId");
    sortByWhat(document_lists, "leaflet_brandname");
    sortByWhat(document_lists, "directory_brandname");

    // label the document if it is an old verison or not 
    let isOldVersionFlags = [];
    // a 2d array to save old version doucument 
    let oldVersionStructure = [];
    // index of oldVersionStructure 
    let lastNewVersion = 0;
    // label the document if it has the same brandname with the previous one 
    let isSameBrandname = [];
    isOldVersionFlags[0] = false;
    isSameBrandname[0] = false;
    for (let i = 1; i < document_lists.length; i++) {
        if (document_lists[i].properties['terumo_ifu:brandName'] === document_lists[i - 1].properties['terumo_ifu:brandName']) {
            isSameBrandname.push(true);
        }
        else {
            isSameBrandname.push(false);
        }

        if (document_lists[i].versionableId === document_lists[i - 1].versionableId) {
            isOldVersionFlags.push(true);
            if (!oldVersionStructure[lastNewVersion]) {
                oldVersionStructure[lastNewVersion] = [];
            }
            oldVersionStructure[lastNewVersion].push(i);
        }
        else {
            isOldVersionFlags.push(false);
            lastNewVersion = i;
        }
    }

    const elements = print_australia_document_table(document_lists, isOldVersionFlags, oldVersionStructure, isSameBrandname);
    aus_document_element.html(elements);
}


/*
 * print Australia page doucument list 
 */
function print_australia_document_table(aus_documents, isOldVersionFlags, oldVersionStructure, isSameBrandname) {

    let elements = [];
    let index = 0;
    let lastNewVersion = 0;
    aus_documents.forEach(entry => {
        let issueDate_str = entry.properties['terumo_ifu:IFU'].split('/');
        let st_date = issueDate_str[issueDate_str.length - 1];
        if (typeof (st_date) != 'undefined') {
            st_date = st_date.trim();
        }

        let doc_description = entry.properties['dc:description'];
        let doc_brandname = entry.properties['terumo_ifu:brandName']

        let filePath = "";
        if (!isEmpty(entry.properties['file:content'])) {
            filePath = `'` + entry.properties['file:content'].data + `'`;
        }

        // generate new version document html
        if (isOldVersionFlags[index] === false) {

            let aus_brandname = '<h3 class="titleSS">' + doc_brandname + '</h3>';
            let aus_description = '<div class="resultList"><div class="item"><table class="tb-products"><tr><th>Description</th>' +
                '<td>' + doc_description + '</td></tr></table></div>';
            let aus_download = '<div class="item"><table class="tb-products"><tr><th>Download</th><td><div class="flex"><dl class="flex"><dt>Leaflet</dt>' +
                '<dd>Issue date : ' + st_date + '</dd></dl><a href=' + filePath + ' class="btnGreen">Newest</a></div></td>';
            let aus_oldButton = '<td><a href class="btnGreenR" id="oldV' + index + '" data-role="oldver">Old Version</a></td>'
            let aus_tail = '</tr></table></div></div>';

            // remove directory brandname if has the same brandname 
            if (isSameBrandname[index]) {
                aus_brandname = '';
            }

            // show old version button or not 
            if (oldVersionStructure[index]) {
                elements.push(aus_brandname + aus_description + aus_download + aus_oldButton + aus_tail);
            }
            else {
                elements.push(aus_brandname + aus_description + aus_download + aus_tail);
            }
            lastNewVersion = index
        }
        // generate old version document html 
        else {
            let aus_download_popup = '<dl><dt>Issue date : ' + st_date + '</dt><dd><a href=' + filePath + '>Download</a></dd></dl>';
            if (!oldVersionHTMLList[lastNewVersion]) {
                oldVersionHTMLList[lastNewVersion] = [];
            }
            oldVersionHTMLList[lastNewVersion].push(aus_download_popup);
        }

        index++;
    });
    return elements;
}


function isEmpty(str) {
    if (typeof str == "undefined" || str == null || str == "")
        return true;
    else
        return false;
}


/* 
 * sort function details 
 */
function sortByWhat(list, key) {
    let i, j, temp;

    // Issue Date (降順)  
    if (key === "issuedate") {
        let date_list = [];
        for (i = 0; i < list.length; i++) {
            let issuedateArray = new Array();
            issuedateArray = list[i].properties['terumo_ifu:IFU'].split('/');
            let st1 = issuedateArray[issuedateArray.length - 1];
            if (typeof (st1) != 'undefined') {
                st1 = st1.trim();
            }
            // console.log(st1);
            let date = new Date(Date.parse(st1));
            if (isNaN(date.getTime()))
                date = new Date(Date.parse('1900-01-01'));
            date_list.push(date);
        }
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                let date1 = date_list[j];
                let date2 = date_list[j + 1];
                if (date1 < date2) {
                    let temp1 = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp1;
                    let temp2 = date_list[j];
                    date_list[j] = date_list[j + 1];
                    date_list[j + 1] = temp2;
                }
            }
    }

    // directory_brandname (昇順)  
    else if (key === "directory_brandname") {
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                let fileName_j = getFileName(list[j]);
                let fileName_j1 = getFileName(list[j + 1]);
                if (fileName_j.toUpperCase() > fileName_j1.toUpperCase()) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                }
            }
    }

    // VersionLabel(降順）
    else if (key === "versionLabel") {
        list.sort(function (a, b) {
            return b.versionLabel - a.versionLabel;
        });
    }

    // leaflet_brandname(昇順) 
    else if (key === "leaflet_brandname") {
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                if (list[j].properties['terumo_ifu:brandName'] > list[j + 1].properties['terumo_ifu:brandName']) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                }
            }
    }

    // versionableID e-IFUの集約のキー(昇順)
    else {
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                if (list[j].versionableId > list[j + 1].versionableId) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                }
            }
    }
}

function getFileName(doc) {
    return doc.path.split('/')[5];
}


/* 
 * move to external site notification
 */
function externelListener() {
    let href;
    const externalclose = function () {
        $('#external').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('externalOpen');
        });
    };
    $('#external button.yes').on('click', function () {
        window.open(href, 'blank');
        externalclose();
        return false;
    });
    $('#external button.no').on('click', function () {
        externalclose();
        return false;
    });
    $('a[target="_blank"]').on('click', function () {
        href = $(this).attr('href');

        $('html').addClass('externalOpen');

        $('#external').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });

        return false;
    });
}



/* 
 * Cookie承認
 */
function cookieLayerInit() {
    const cookieLayerclose = function () {
        $('#cookieLayer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('cookieLayerOpen');
        });
    };

    const cookieOk = function () {
        $.cookie('cookieaccepted', 'true', { expires: 1, path: '/' });
        cookieLayerclose();
    };
    $('#cookieLayer button.yes').on('click', function () {
        cookieOk();
        disclaimerInit();
        return false;
    });

    if ($.cookie('cookieaccepted') === undefined) {
        $('html').addClass('cookieLayerOpen');

        $('#cookieLayer').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    } else {
        disclaimerInit();
    }
}


/* 
 * 免責画面
 */
function disclaimerInit() {
    const disclaimerClose = function () {
        $('#disclaimer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('disclaimerOpen');
        });
    };
    $('#disclaimer .disclaimer-cont ul li .btnContinue').on('click', function () {
        disclaimerClose();
        $.cookie('disclaimer-au', 'true', { expires: 1, path: '/' });
        return false;
    });
    $('#disclaimer .disclaimer-cont ul li .btnBack').on('click', function () {
        if (window.opener) {
            window.close();
        } else {
            window.history.back();
        }
        return false;
    });

    if ($.cookie('disclaimer-au') === undefined) {
        $('html').addClass('disclaimerOpen');
        $('#disclaimer').css({
            opacity: 0
        }).animate({
            opacity: 1
        });
    }
}

$(window).on('load', function () {
    frontEndLogic();

    // トップリサイズ
    let ths = this;
    ths.ontopresize = function () {
        let _display = $('header .headerInr .menu').css('display');
        if (_display === 'none') {
            let ht = 0;
            let allHt = 0;
            $('ul.vertical.products li').each(function () {
                allHt = allHt + $(this).outerHeight();
                if (ht < $(this).outerHeight()) {
                    ht = $(this).outerHeight();
                }
            });
            allHt = Math.floor(allHt / 3);
            allHt = allHt + ht;
            $('ul.vertical.products').css({
                height: allHt
            });
        } else {
            $('ul.vertical.products').css({
                height: ''
            });
        }
    };
    if ($('ul.vertical.products')[0]) {
        $(window).on('resize.products', function () {
            ths.ontopresize();
        });
        setTimeout(function () {
            ths.ontopresize();
        }, 100);
    }
});

function frontEndLogic() {
    $(document).on('click', 'nav .tit', function () {
        if ($(this).hasClass('close')) {
            $(this).removeClass('close');
            $(this).next().slideDown('normal', function () { });
        } else {
            $(this).addClass('close');
            $(this).next().slideUp('normal', function () { });
        }
        return false;
    });

    $('.resultList .item').each(itemAct);

    function itemAct(i) {
        let $me = $(this);
        let $next = $me.next();
        if ($next.hasClass('oldVer')) {
            $next = $me.next().next().next();
        }

        if (i !== 0) {
            let _display = $('header .headerInr .menu').css('display');
            if (_display === 'none') {
                if (!$me.closest('.oldVer')[0]) {
                    $me.find('.itemHead th span').hide();
                    $me.find('.itemHead th').hide();
                }
            }
        }
        $me.find('button').on('click', function () {
            let _display = $('header .headerInr .menu').css('display');
            if ($(this).hasClass('minus')) {
                $(this).removeClass('minus');
                $me.removeClass('open');

                //自分自身
                $me.find('.info').slideUp();
                if ($me.prev().hasClass('open')) {
                    //何もしない
                } else if (i !== 0) {
                    if (_display === 'none') {
                        $me.find('.itemHead thead tr th span').slideUp('normal', function () {
                            $(this).parent().hide();
                        });
                    }
                }

                //下の要素
                if ($('header .headerInr .menu').css('display') === 'none') {
                    if (_display === 'none') {
                        if ($next.hasClass('open')) {
                            //何もしない
                        } else {
                            $next.find('.itemHead thead tr th span').slideUp('normal', function () {
                                $(this).parent().hide();
                            });
                        }
                    }
                }
            } else {
                $(this).addClass('minus');

                //自分自身
                $me.addClass('open');
                $me.find('.info').slideDown();

                if (_display === 'none') {
                    $me.find('.itemHead thead tr th').show();
                    $me.find('.itemHead thead tr th span').slideDown();
                }

                //下の要素
                if (_display === 'none') {
                    $next.find('.itemHead thead tr th').show();
                    $next.find('.itemHead thead tr th span').slideDown();
                }
            }
            return false;
        });
    }

    $('.oldVer').each(oldVerAct);
    function oldVerAct(i) {
        if (i) {
            //do nothing
        }
        let scrollTop = 0;
        let $me = $(this);
        $me.hide();

        const oldVerClose = function () {
            $me.fadeOut('normal', function () {
                $('body').css({
                    top: scrollTop,
                    position: 'static',
                    overflow: 'visible'
                });
                $(window).scrollTop(scrollTop);
            });
        };

        $me.next().on('click', function () {
            scrollTop = $(window).scrollTop();
            $('body').css({
                top: scrollTop * -1,
                left: 0,
                right: 0,
                position: 'fixed',
                overflow: 'hidden'
            });
            $me.fadeIn();
            onresultresize();
            return false;
        });
        $me.find('.btnClose').on('click', function () {
            oldVerClose();

            return false;
        });
        $me.on('click', function (e) {
            if (e.target === e.currentTarget) {
                oldVerClose();
            }
        });
    }


    let scrollTop = 0;
    $(document).on('click', 'nav .navTit .btnClose', function () {
        $('nav').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('navOpen');
            $('html,body').scrollTop(scrollTop);
            scrollTop = 0;
            $('body').css({
                top: 0
            });
        });
        return false;
    });
    $('.btnFilter a').on('click', function () {
        if ($('html').hasClass('navOpen')) {
            $('html').removeClass('navOpen');
        } else {
            scrollTop = $('html,body').scrollTop();
            $('body').css({
                top: scrollTop * -1
            });
            $('html').addClass('navOpen');

            $('nav').css({
                opacity: 0
            }).animate({
                opacity: 1
            });
        }
        return false;
    });

    $(document).on('click', 'header .headerInr .menu', function () {

        let $nav = $('header .headerInr .nav');

        if ($('html').hasClass('menuOpen')) {
            $nav.css({
                opacity: 1
            }).animate({
                opacity: 0
            }, 'normal', function () {
                $('html').removeClass('menuOpen');
                $('html,body').scrollTop(scrollTop);
                scrollTop = 0;
                $nav.css({
                    opacity: 1
                });
            });
        } else {
            scrollTop = $('html,body').scrollTop();
            $('html').addClass('menuOpen');
            $nav.css({
                top: $('header').outerHeight(),
                opacity: 0
            }).animate({
                opacity: 1
            });
        }
        return false;

    });

    $('.resultHead .result dl dd').on('click', function () {
        if ($('header .headerInr .menu').css('display') === 'none') return false;
        let $next = $(this);
        $next.css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('helpOpen');
            $next.removeClass('open');
            $('html,body').scrollTop(scrollTop);
            $('body').css({
                top: 0
            });
            scrollTop = 0;
        });

        return false;
    });
    $('.resultHead .result dl dt').on('click', function () {
        if ($('header .headerInr .menu').css('display') === 'none') return false;
        let $next = $(this).next();

        if ($('html').hasClass('helpOpen')) {
            $next.css({
                opacity: 1
            }).animate({
                opacity: 0
            }, 'normal', function () {
                $('html').removeClass('helpOpen');
                $next.removeClass('open');
                $('html,body').scrollTop(scrollTop);
                $('body').css({
                    top: 0
                });
                scrollTop = 0;
            });
        } else {
            scrollTop = $('html,body').scrollTop();
            $next.addClass('open');
            $('html').addClass('helpOpen');
            $('body').css({
                top: scrollTop * -1
            });

            $next.css({
                opacity: 0
            }).animate({
                opacity: 1
            }, 'normal', function () {
            });


        }
        return false;
    });
    (function () {
        $('.readMore').on('click', function () {
            let $parent = $(this).parent();
            if ($parent.hasClass('open')) {
                $parent.find('.storage').slideUp();
                $parent.removeClass('open');
                let top = $parent.offset().top;
                $('html,body').animate({
                    scrollTop: top
                });
            } else {
                $parent.find('.storage').slideDown();
                $parent.addClass('open');
            }
            return false;
        });
    })();


    //検索結果リサイズ
    const onresultresize = function () {
        let _display = $('header .headerInr .menu').css('display');
        if (_display === 'none') {
            $('.resultList .item .itemHead').each(function () {
                let $itemHead = $(this);
                let ht = 0;
                $itemHead.find('td').each(function () {
                    let oh = $(this).outerHeight();
                    if (ht < oh) ht = oh;
                });

                $itemHead.find('td').css({
                    height: ht
                });
            });
        }
    };
    if ($('.resultList .item .itemHead')[0]) {
        $(window).on('resize.result', onresultresize);
        onresultresize();
    }

    const onresize = function () {
        let _display = $('header .headerInr .menu').css('display');
        if (_display === 'none') {
            $('html').removeClass('menuOpen');
        }
    };
    $(window).on('resize.result', onresize);
    onresize();
}